function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import isEmpty from 'lodash/isEmpty';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import Page from '../../../components/page/Page';
import { MEMBERSHIP } from '../../../constants/membership';
import { alertWarning, hideModal, setMembershipPriceId } from '../../../redux/actions';
import text from '../../../text';
import { getUserMembership } from '../../../utilities/user';
import MembershipInvoice from '../Invoice/MembershipInvoice';
import MembershipManagementWizard from '../MembershipWizard/MembershipManagementWizard';
import PaymentProvider from '../PaymentContext';
import { useQuery } from '../../../hooks/useQuery';
import { isRouteIncluded } from '../../../utilities/routes';
import routes from '../../../routes/constants';
import { profileSelectors } from '../../../redux/selectors/profile';
import { useRedirect } from '../../../hooks/useRedirect';
import useMembershipButton from '../../../hooks/useMembershipButton';
import { START_TRIAL_MODAL } from '../../../components/modal/StartTrialModal/StartTrialModal';
var cleanRedirectPath = function(path) {
    if (!path) return null;
    try {
        // Handle paths that contain full URLs
        if (path.includes('://')) {
            var url = new URL(path);
            return url.pathname + url.search + url.hash;
        }
        return path;
    } catch (e) {
        console.error('Error parsing redirect path:', e);
        return path;
    }
};
var MembershipManagement = function() {
    var _location_state;
    var queryParams = useQuery();
    var history = useHistory();
    var location = useLocation();
    var dispatch = useDispatch();
    var currentUser = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile
        };
    }).currentUser;
    var _useState = _sliced_to_array(useState(false), 2), alertDispatched = _useState[0], setAlertDispatched = _useState[1];
    var isUpgradeRecommended = useSelector(profileSelectors.getIsUpgradeRecommended);
    var redirect = useRedirect();
    var handleMembershipClick = useMembershipButton().handleMembershipClick;
    var view3dTooltipText = isUpgradeRecommended ? text('upgrade') : text('startNdayTrial', {
        n: 14
    });
    var handleDispatch = useCallback(function(membershipPriceId) {
        dispatch(setMembershipPriceId(membershipPriceId));
        if (location.state && location.state.alert && !alertDispatched) {
            setAlertDispatched(true);
            Promise.resolve().then(function() {
                // deferred dispatch to wait state updates
                dispatch(alertWarning(location.state.alert));
            });
        }
    }, [
        dispatch,
        location.state,
        alertDispatched
    ]);
    useEffect(function() {
        var membershipInfo = getUserMembership(currentUser);
        var membershipPriceId;
        if (!membershipInfo && !isEmpty(currentUser)) {
            membershipPriceId = MEMBERSHIP.MONTHLY.PRICE_ID;
        } else {
            membershipPriceId = membershipInfo === null || membershipInfo === void 0 ? void 0 : membershipInfo.price_id;
        }
        handleDispatch(membershipPriceId);
    }, [
        handleDispatch,
        currentUser,
        history
    ]);
    /**
   * Handle when redirectTo contains 3D viewer route.
   * This is to dispatch alert warning when the user cancels upgrade or go backs to dashboard
   */ var redirectTo = useMemo(function() {
        var _location_state;
        var stateRedirect = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.redirectTo;
        var queryRedirect = queryParams.get('redirectTo');
        if (!stateRedirect && !queryRedirect) return null;
        return stateRedirect ? _object_spread_props(_object_spread({}, stateRedirect), {
            path: cleanRedirectPath(stateRedirect.path)
        }) : {
            path: cleanRedirectPath(queryRedirect),
            label: queryParams.get('label')
        };
    }, [
        (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.redirectTo,
        queryParams
    ]);
    var isViewer3dRoute = isRouteIncluded([
        routes.view3D.root
    ]);
    var showMembershipAlert = useCallback(function() {
        dispatch(alertWarning(/*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("a", {
            onClick: function() {
                handleMembershipClick({
                    redirectTo: {
                        path: routes.view3DExternal.root,
                        label: text('navigateToRoute', {
                            navigation: 'Continue',
                            routeName: text('viewer3D')
                        })
                    }
                }, false, function() {
                    return redirect.push(routes.view3DExternal.root);
                }, {
                    onHide: function() {
                        dispatch(hideModal(START_TRIAL_MODAL));
                        dispatch(alertWarning(view3dTooltipText, {
                            className: 'v2 content-minus-sidenav'
                        }));
                    },
                    onStartTrial: function() {
                        return dispatch(hideModal(START_TRIAL_MODAL));
                    }
                });
            },
            className: "mr-1 white-underlined-link"
        }, view3dTooltipText), text('accessThe3dViewer')), {
            className: 'v2 content-minus-sidenav'
        }));
    }, [
        dispatch,
        view3dTooltipText,
        handleMembershipClick,
        redirect
    ]);
    var handleGoBack = useCallback(function() {
        if ((redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.path) && isViewer3dRoute(redirectTo.path)) {
            showMembershipAlert();
        }
        history.goBack();
    }, [
        redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.path,
        isViewer3dRoute,
        history,
        showMembershipAlert
    ]);
    // end handle when redirectTo contains 3D viewer route
    return /*#__PURE__*/ React.createElement(PaymentProvider, null, /*#__PURE__*/ React.createElement(Page, {
        className: "MembershipManagement"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "invoice-section"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "link",
        onClick: handleGoBack
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "caret-left"
    }), text('back')), /*#__PURE__*/ React.createElement(MembershipInvoice, null)), /*#__PURE__*/ React.createElement("div", {
        className: "section"
    }, /*#__PURE__*/ React.createElement(MembershipManagementWizard, null))));
};
export default MembershipManagement;
